module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid32_960x850.49cb315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid32_960x850.jpg
// module id = UGep
// module chunks = 0